// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".finishing-Parking-block__separate[data-v-349a629e]{margin-top:120px}@media(max-width:639px){.finishing-Parking-block__separate[data-v-349a629e]{margin-top:60px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
